// these urls have unique id's where we do not want them to be grouped separately
export const requestUrlsWithUniqueIds = ['/web-api/v1/orders/', '/web-api/v1/password_resets/'];
